module.exports = __webpack_public_path__ + "static/media/european-union.0ae78626.png";